import React from 'react';
import SEOHead from '../components/SEOHead';
import { 
  Box, 
  Container, 
  Typography, 
  Grid, 
  Card, 
  CardContent, 
} from '@mui/material';
import { 
  LocationOn, 
  Phone, 
  Email, 
  AccessTime, 
} from '@mui/icons-material';
import ContactUsForm from '../components/ContactUs';

function ContactUs() {

  const contactInfo = [
    {
      icon: <LocationOn sx={{ color: '#9f2122', fontSize: '2rem' }} />,
      title: 'Address',
      content: '10 Anson Road #35-02A International Plaza, Singapore 079903',
      subtitle: 'Located in CBD area of Singapore'
    },
    {
      icon: <Phone sx={{ color: '#9f2122', fontSize: '2rem' }} />,
      title: 'Phone & WhatsApp',
      content: '+65 89208197',
      subtitle: 'Available 9 AM - 9 PM (Mon-Sun)'
    },
    {
      icon: <Email sx={{ color: '#9f2122', fontSize: '2rem' }} />,
      title: 'Email',
      content: 'info@chihuimandarin.com',
      subtitle: 'We respond within 24 hours'
    },
    {
      icon: <AccessTime sx={{ color: '#9f2122', fontSize: '2rem' }} />,
      title: 'Office Hours',
      content: 'Monday - Sunday: 9:00 AM - 9:00 PM'
    }
  ];


  return (
    <>
      <SEOHead pageKey="contact" />
      <Box sx={{ minHeight: '100vh', bgcolor: '#fafafa'}}>
      {/* Header Section */}
      <Box
        sx={{
          py: 8,
          background: 'linear-gradient(135deg, rgba(7, 40, 75, 0.05) 0%, rgba(159, 33, 34, 0.03) 100%)',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '10%',
            right: '5%',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'rgba(159, 33, 34, 0.05)',
            zIndex: 0
          }
        }}
      >
        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontFamily: 'serif',
                fontWeight: 700,
                color: '#07284b',
                mb: 3,
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                lineHeight: 1.2
              }}
            >
              Contact Us
            </Typography>
            
            <Typography
              variant="h6"
              sx={{
                color: '#5a6c7d',
                maxWidth: 800,
                mx: 'auto',
                fontSize: '1.2rem',
                lineHeight: 1.6
              }}
            >
              Get in touch with us to start your Chinese learning journey. 
              We're here to help you choose the perfect course for your needs.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxWidth="xl" sx={{ py: 8 }}>
        <Box sx={{ mb: 6 }}>
            <Typography
            variant="h4"
            sx={{
                fontFamily: 'serif',
                fontWeight: 700,
                color: '#07284b',
                mb: 4
            }}
            >
            Get in Touch
            </Typography>
            
            <Typography
            variant="body1"
            sx={{
                color: '#5a6c7d',
                fontSize: '1.1rem',
                lineHeight: 1.8,
                mb: 4
            }}
            >
            We're committed to providing exceptional Chinese language education. 
            Reach out to us through any of the channels below, and we'll get back to you promptly.
            </Typography>
        </Box>
        {/* Contact Cards */}
        <Grid container spacing={3}>
              {contactInfo.map((info, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Card
                    sx={{
                      height: '100%',
                      borderRadius: 3,
                      boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
                      border: '1px solid rgba(0,0,0,0.05)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0 12px 35px rgba(0,0,0,0.12)'
                      }
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box sx={{ mb: 2 }}>
                        {info.icon}
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{
                          color: '#07284b',
                          fontWeight: 600,
                          mb: 1
                        }}
                      >
                        {info.title}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: '#5a6c7d',
                          fontWeight: 500,
                          mb: 1
                        }}
                      >
                        {info.content}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#9f2122',
                          fontSize: '0.9rem'
                        }}
                      >
                        {info.subtitle}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
        </Container>


        {/* Contact Form */}
        <ContactUsForm />

      </Box>
    </>
  );
}

export default ContactUs;
